<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <img
          src="@/assets/images/logo/logo.png"
          alt=""
          class="navbar-logo"
        >
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Halo! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Harap login untuk melanjutkan
          </b-card-text>

          <!-- Alert -->
          <b-alert
            variant="warning"
            :show="alert.length"
          >
            <div class="alert-body">
              {{ alert }}
            </div>
          </b-alert>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group
                label="Kata Sandi"
                label-for="login-password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="isSubmitting"
                @click="validationForm"
              >
                <b-spinner
                  v-if="isSubmitting"
                  small
                />
                Masuk
              </b-button>

              <hr>

              <!-- Login google -->
              <b-overlay :show="loadingLoginGoogle">
                <div
                  class="position-relative overflow-hidden mt-1"
                  style="border-radius: 0.357rem;"
                >
                  <!-- Custom Button -->
                  <b-button
                    variant="flat-secondary"
                    block
                    class="d-flex align-items-center justify-content-center m-0"
                    style="pointer-events: none; background-color: #ffffff !important; color: #3c4043 !important; border: 1px solid #dadce0 !important; font-weight: 500; font-family: Roboto, sans-serif; height: 38px; font-size: 14px; padding: 0;"
                  >
                    <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg" class="mr-1">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                    </svg>
                    Login dengan Google
                  </b-button>

                  <!-- Invisible GSI Button -->
                  <div
                    class="position-absolute d-flex align-items-center justify-content-center"
                    style="top: 0; left: 0; right: 0; bottom: 0; opacity: 0.01; z-index: 10; transform: scale(4);"
                  >
                    <div id="google-login-button" />
                  </div>
                </div>
              </b-overlay>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BOverlay,
  BRow,
  BCol,
  BAlert,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
// eslint-disable-next-line import/no-cycle
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
// import { admin } from '@/libs/acl/roles/admin'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BOverlay,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      alert: '',
      status: '',
      password: '',
      userEmail: '',
      isSubmitting: false,
      loadingLoginGoogle: false,
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    if (this.$route.query.email) {
      this.userEmail = this.$route.query.email
      const restQuery = { ...this.$route.query }
      delete restQuery.email
      this.$router.replace({ query: restQuery }).catch(() => {})
    }

    this.importGoogle()
    this.reloadGoogleLib()
  },
  methods: {
    async loginGoogle(data) {
      const body = {
        token: data.credential,
      }

      this.loadingLoginGoogle = true

      // authenticate user
      useJwt.loginGoogle(body)
        .then(this.onSignedIn)
        .catch(e => {
          this.alert = e.response.data.message
        })
        .finally(() => {
          this.loadingLoginGoogle = false
        })
    },
    async loadGoogleLib() {
      // eslint-disable-next-line no-undef
      google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        callback: this.loginGoogle,
      })

      const element = document.getElementById('google-login-button')

      // eslint-disable-next-line no-undef
      google.accounts.id.renderButton(element, {
        type: 'standard',
        size: 'large',
        text: 'signin_with',
        shape: 'rectangular',
        logo_alignment: 'center',
        // Lebar dimaksimalkan ke 400 untuk memastikan area klik maksimal saat di-scale
        width: 400,
      })

      // eslint-disable-next-line no-undef
      google.accounts.id.disableAutoSelect()
      // eslint-disable-next-line no-undef
      google.accounts.id.prompt() // also display the One Tap dialog
    },
    importGoogle() {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://accounts.google.com/gsi/client')
      script.setAttribute('async', true)
      script.setAttribute('defer', true)
      document.head.appendChild(script)
    },
    reloadGoogleLib() {
      // eslint-disable-next-line no-undef
      if (typeof google !== 'undefined') {
        this.loadGoogleLib()
      } else {
        setTimeout(this.reloadGoogleLib, 250)
      }
    },
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.alert = ''
          this.isSubmitting = true

          useJwt.login({
            email: this.userEmail,
            password: this.password,
          })
            .then(this.onSignedIn)
            .catch(e => {
              this.alert = e.response.data.message
            })
            .finally(() => {
              this.isSubmitting = false
            })
        }
      })
    },
    async onSignedIn(response) {
      const tokens = response?.data?.data || {}
      useJwt.setToken(tokens.access_token, tokens.access_token_expires_at)
      useJwt.setRefreshToken(tokens.refresh_token, tokens.refresh_token_expires_at)
      const user = await this.loadUser()
      const ability = user.permissions

      const userData = {
        ...user,
        role: user.roles,
        ability,
      }

      this.$ability.update(ability)
      this.$store.commit('auth/UPDATE_USER_DATA', userData)
      const { redirectTo } = this.$route.query
      if (redirectTo) {
        this.$router.replace(redirectTo)
        return
      }
      this.$router.replace(getHomeRouteForLoggedInUser(user.roles))
    },
    loadUser() {
      return this.$http.get('v1/admin/me')
        .then(response => response.data.data)
        .catch(() => null)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
